import { render, staticRenderFns } from "./GameOverModal.vue?vue&type=template&id=fbae55a8&scoped=true"
import script from "./GameOverModal.vue?vue&type=script&lang=js"
export * from "./GameOverModal.vue?vue&type=script&lang=js"
import style0 from "./GameOverModal.vue?vue&type=style&index=0&id=fbae55a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbae55a8",
  null
  
)

export default component.exports